var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78358 10.8188L7.95827 3.21506L20.9933 3.51453L20.8186 11.1183M7.55898 20.595L5.38649 20.5451C4.8103 20.5319 4.26298 20.2903 3.86492 19.8735C3.46686 19.4567 3.25066 18.8989 3.2639 18.3227L3.38868 12.8915C3.40192 12.3153 3.6435 11.768 4.06028 11.3699C4.47706 10.9718 5.03491 10.7556 5.61109 10.7689L22.9911 11.1682C23.5672 11.1814 24.1146 11.423 24.5126 11.8398C24.9107 12.2566 25.1269 12.8144 25.1136 13.3906L24.9889 18.8218C24.9756 19.398 24.734 19.9453 24.3173 20.3434C23.9005 20.7415 23.3426 20.9576 22.7665 20.9444L20.594 20.8945M7.6588 16.25L20.6938 16.5495L20.4941 25.2395L7.45916 24.94L7.6588 16.25Z",
    stroke: "#06513D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrints);
export default __webpack_public_path__ + "static/media/prints.3f41282dcc928c113d12e9dc969362f8.svg";
export { ForwardRef as ReactComponent };